/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Box } from "@material-ui/core";
import { LeftBorderHeadline } from "components/atoms/headline/LeftBorderHeadline";
import { PCView, SPView } from "components/common/MediaQuery";
import { GIFT_LETTER_EVENT_ID } from "constants/featureFlags";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { BreadcrumbNavigation } from "ui/BreadcrumbNavigation";

export const EventGiftLetter: FC = () => {
  const GIFT_LETTER_ITEMS: string[] = [
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_1.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_2.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_3.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_4.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_5.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_6.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_7.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_8.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_9.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_10.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_11.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_13.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_14.png",
    // 08
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_17.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_18.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_19.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_20.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_21.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_23.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_24.png",
    // 12
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_26.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_27.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_32.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_33.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_34.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_35.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_36.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_38.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_39.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_41.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_42.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_46.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_47.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_48.png",
    "https://public.spwn.jp/giftletters/evt_s7X9CkAylqheiZH1345L/giftletter_51.png",
  ];

  const eventId = GIFT_LETTER_EVENT_ID;

  return (
    <React.Fragment>
      <BreadcrumbNavigation
        breadcrumbs={[
          { label: "ホーム", link: "/" },
          { label: "イベント一覧", link: "/events" },
          {
            label: "銀河アリス LAST LIVE -FINAL INVASION-",
            link: `/events/${eventId}`,
          },
          { label: "ギフトレター", link: null },
        ]}
      />

      <Box component={"main"}>
        {/* イベントタイトルなどの情報を表示する */}
        <section
          css={css`
            background-color: #fff;
            padding: 20px 0 40px;
            @media screen and (min-width: 768px) {
              padding: 74px 24px 85px;
            }
          `}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            gridGap={"40px"}
            width={"100%"}
            maxWidth={"980px"}
            margin={"0 auto"}
          >
            <PCView>
              <LeftBorderHeadline
                title={"GIFT LETTER"}
                subTitle={"ギフトレター"}
                fontColor={"secondary"}
              />
            </PCView>

            <div
              css={css`
                display: flex;
                flex-direction: column;
                gap: 16px;
                margin: 0 20px;
                @media screen and (min-width: 768px) {
                  flex-direction: row;
                  gap: 40px;
                  align-items: center;
                  margin: 0;
                }
              `}
            >
              <img
                src={"/images/gift-letter/event_thumbnail.png"}
                alt={"銀河アリス LAST LIVE -FINAL INVASION-"}
                width={"100%"}
                css={css`
                  box-sizing: border-box;
                  @media screen and (min-width: 768px) {
                    max-width: 380px;
                  }
                `}
              />

              <Box
                paddingBottom={["16px", "0"]}
                fontSize={["20px", "24px"]}
                fontWeight={"bold"}
                borderBottom={["1px solid #eee", "none"]}
              >
                銀河アリス LAST LIVE -FINAL INVASION-
              </Box>
            </div>

            <SPView>
              <div
                css={css`
                  margin: 0 20px;
                `}
              >
                <Link to={`/events/${eventId}/goods`}>
                  <img
                    src="/images/gift-letter/gift_letter_banner_small.png"
                    alt="ギフトレター贈ろう"
                    width={"100%"}
                  />
                </Link>
              </div>
            </SPView>
          </Box>
        </section>

        {/* ギフトレター一覧を表示する */}
        <section
          css={css`
            padding: 24px 16px 69px;
            background-image: url("/images/gift-letter/gift_letter_bg.png");
            background-size: cover;
            background-position: top center;
            @media screen and (min-width: 768px) {
              padding: 48px 24px 100px;
            }
          `}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            gridGap={"56px"}
            width={"100%"}
            margin={"0 auto"}
            maxWidth={"1488px"}
          >
            <PCView>
              <Link to={`/events/${eventId}/goods`}>
                <img
                  src="/images/gift-letter/gift_letter_banner.png"
                  alt="ギフトレター贈ろう"
                  css={css`
                    display: block;
                    width: 100%;
                    height: auto;
                    margin: 0 auto;
                    max-width: 980px;
                  `}
                />
              </Link>
            </PCView>

            {/* ギフトレターのコンテンツをここに追加 */}
            {GIFT_LETTER_ITEMS.length === 0 ? (
              <Box
                component={"section"}
                padding={["96px 0 294px", "168px 0 770px"]}
              >
                <Box
                  component={"p"}
                  color={"#fff"}
                  fontSize={["16px", "24px"]}
                  textAlign={"center"}
                >
                  掲載開始までしばらくお待ちください
                </Box>
              </Box>
            ) : (
              <div
                css={css`
                  display: grid;
                  gap: 24px;
                  grid-template-columns: 1fr;
                  @media screen and (min-width: 768px) {
                    grid-template-columns: repeat(3, 1fr);
                  }
                `}
              >
                {GIFT_LETTER_ITEMS.map((item, index) => {
                  return (
                    <Box key={item}>
                      <img
                        src={item}
                        alt={`ギフトレター${index + 1}`}
                        style={{
                          width: "100%",
                          height: "auto",
                        }}
                      />
                    </Box>
                  );
                })}
              </div>
            )}
          </Box>
        </section>
      </Box>
    </React.Fragment>
  );
};
